import React from 'react';
import SpotifyEmbed from '../components/SpotifyEmbed';

const SPOTIFY_URL = 'https://open.spotify.com/artist/06HXnS61xDNUfn9B1pATdM';

const Musikk: React.FC = () => (
  <div className="bg-[#080808] text-white min-h-screen section-padding">
    <div className="container-responsive max-w-3xl">

      <div className="mb-10 sm:mb-14">
        <p className="text-xs font-bold tracking-[0.25em] uppercase mb-3" style={{ color: '#9bf01e' }}>
          <span style={{ opacity: 0.5 }}>{'// '}</span>Musikk
        </p>
        <h1 className="text-4xl sm:text-6xl font-extrabold text-white mb-5 tracking-tight leading-none">
          Lytt til Smuglergods
        </h1>
        <p className="text-base sm:text-lg leading-relaxed max-w-xl" style={{ color: 'rgba(255,255,255,0.55)' }}>
          Vi lager "musikk". Hør hele katalogen vår — fra gåsehud og sprengte trommehinner til plater du kan grine med/av.
        </p>
      </div>

      <SpotifyEmbed height={420} />

      <div className="mt-6">
        <a
          href={SPOTIFY_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#1DB954] hover:bg-[#1ed760] text-black font-bold py-2.5 px-5 rounded-full transition-all text-sm"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.669 11.538a.498.498 0 0 1-.686.165c-1.879-1.147-4.243-1.407-7.028-.77a.499.499 0 0 1-.222-.973c3.048-.696 5.662-.397 7.77.892a.5.5 0 0 1 .166.686zm.979-2.178a.624.624 0 0 1-.858.205c-2.15-1.321-5.428-1.704-7.972-.932a.625.624 0 0 1-.362-1.194c2.905-.881 6.517-.454 8.986 1.063a.624.624 0 0 1 .206.858zm.084-2.268C10.154 5.56 5.9 5.419 3.438 6.166a.748.748 0 1 1-.434-1.432c2.825-.857 7.523-.692 10.492 1.07a.747.747 0 1 1-.764 1.288z"/>
          </svg>
          Åpne i Spotify
        </a>
      </div>

    </div>
  </div>
);

export default Musikk;
